import React from "react";

export default function LevelDetails() {
  return (
    <div className="min-h-screen font-Outfit flex justify-center items-start">
      <div className="w-full p-6">
        <h2 className="text-lg font-semibold mb-4">Level Details</h2>
        <h3 className="text-2xl font-bold text-[#5608D4] mb-4">
          FULL - TIME SENIOR
        </h3>

        {/* Description */}
        <p className="text-black text-lg leading-relaxed mb-8">
          Lorem ipsum dolor sit amet consectetur. Tellus ut integer velit
          egestas mi pretium eu odio. Fames tellus consectetur urna sit euismod
          ipsum egestas in. Vulputate eget tortor risus sit. Pharetra mi
          tincidunt amet donec vitae ornare. Rhoncus lectus amet in risus
          consequat malesuada et. Sed et dolor quam lacus aenean sociis.
          Ullamcorper laoreet et ipsum ut eget. Ut amet purus lobortis tellus
          neque imperdiet. Tempus sagittis adipiscing amet sagittis ac.
        </p>

        <div className="space-y-3 text-[#071C50] text-base">
          <div className="flex gap-8">
            <span className="font-medium">Date created -</span>
            <span className="text-blue-800">11th April, 2024</span>
          </div>
          <div className="flex gap-8">
            <span className="font-medium">Total members -</span>
            <span className="text-blue-800">300</span>
          </div>
          <div className="flex gap-8">
            <span className="font-medium">Monthly basic salary -</span>
            <span className="text-blue-800">200,000</span>
          </div>
          <div className="flex gap-8">
            <span className="font-medium">Total monthly compensation -</span>
            <span className="text-blue-800">200,000</span>
          </div>
        </div>

        <div className="flex justify-start items-end gap-4 mt-40">
          <button className="px-6 py-4 w-60 border border-blue-500 rounded-lg text-blue-600 hover:bg-blue-50">
            Delete level
          </button>
          <button className="px-6 py-4 w-60 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
            Update
          </button>
        </div>
      </div>
    </div>
  );
}
